import { styled } from 'styled-components';

import { cssBreakpoints, maxWidth } from '#/theme/theme';

export const ViewUserProfilePageNotFoundHolder = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;

  margin: 98px auto;
  max-width: ${maxWidth[3]}px;

  @media (min-width: ${cssBreakpoints.mdUp}) {
    gap: 60px;
  }

  @media (max-width: ${cssBreakpoints.mdDown}) {
    gap: 22px;
  }
`;

export const ViewUserProfilePageNotFoundImageHolder = styled.div`
  @media (min-width: ${cssBreakpoints.mdUp}) {
    width: 50%;
  }

  img {
    width: 100%;
  }
`;

export const ViewUserProfilePageNotFoundTextHolder = styled.div`
  @media (min-width: ${cssBreakpoints.mdUp}) {
    width: 50%;
  }
`;
